import { Button } from "@/common/components/button";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  getSalesTableData,
  newFundRequestForm,
  salesStatisticCards,
  salesTableHeaders,
  salesTableKeys,
} from "../data";
import { FinancialWrapper } from "../style";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useState } from "react";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";

const PharmacyHeadFinancialManagement = () => {
  const [salesPerpage, setSalesPerpage] = useState(10);
  const [newRequestModal, setNewRequestModal] = useState<boolean>(false);
  const {
    data: salesData,
    meta: salesMeta,
    loading: salesLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${salesPerpage}&page=${salesPerpage}`
  );
  const handleNewFundSubmit = () => {
    alert("submission requested");
  };
  return (
    <FinancialWrapper>
      <div className="card-wrapper">
        {salesStatisticCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div className="cta-stock">
        <Button onClick={() => setNewRequestModal(true)}>Request Stock</Button>
        <Button secondary>Export</Button>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={salesTableHeaders}
          tableKeys={salesTableKeys}
          tableData={getSalesTableData(salesData)}
          tableTitle="Fund Allocation Request"
          tableSubtitle={(salesMeta?.total_count ?? "0") + " Requests"}
          loading={salesLoading}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={salesMeta?.total_pages}
          onNextPage={(event: any) => setSalesPerpage(event.selected)}
          onPerPageChange={(event: any) =>
            setSalesPerpage(event?.target?.value)
          }
        />
      </div>
      <Modal
        title="New Fund Request"
        isOpen={newRequestModal}
        close={() => setNewRequestModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={newFundRequestForm}
            processInputs={handleNewFundSubmit}
          />
        </div>
      </Modal>
    </FinancialWrapper>
  );
};

export default PharmacyHeadFinancialManagement;
